// 课程推荐列表
const recommendList = () => import('@/pages/arkHome/recommendList.vue');
export default [
  {
    path: '/recommendList',
    name: 'recommendList',
    component: recommendList,
    meta: {
      title: '课程列表',
    },
  },
];
